import VueScrollTo from "vue-scrollto";
export class inPageNavigation {

  constructor(component) {
    this.component = component;
  }

  updateComponent(content, is_navi = true) {
    this.component.the_content = content;
    if (is_navi) {
      this.component.is_left = this.current > 0;
      this.component.is_right = this.current < this.length -1;
    } else {
      this.component.is_left = false;
      this.component.is_right = false;
    }

  }

  getCurrentNavi() {
    const current = sessionStorage.getItem(`fcwp_in_page_navigation`);
    return current !== null ? parseInt(current) : 0;
  }

  setCurrentNavi(val) {
    sessionStorage.setItem(`fcwp_in_page_navigation`, val);
  }

  unsetCurrentNavi() {
    sessionStorage.removeItem('fcwp_in_page_navigation');
  }

  setCurrentPage(id) {
    sessionStorage.setItem(`fcwp_current_page`, id);
  }

  getCurrentPage() {
    return sessionStorage.getItem(`fcwp_current_page`);
  }

  setContent(content, item_id) {
    if (item_id != this.getCurrentPage()) {
      this.setCurrentPage(item_id);
      this.unsetCurrentNavi();
    }
    if (!content.includes('<!--nextpage-->')) {
      this.updateComponent(content, false);

    } else {
      this.elements = content.split('<!--nextpage-->');
      this.length = this.elements.length;
      this.current = this.getCurrentNavi();

      this.updateComponent(this.elements[this.current]);
      this.listenKeyboard();
    }
  }

  listenKeyboard() {
    onkeydown = (e) => {
      if (e.key == 'ArrowRight') {
        const elem = document.getElementById('in_page_next');
        if (typeof elem !== 'undefined') elem.classList.add('hover');
      }
      if (e.key == 'ArrowLeft') {
        const elem = document.getElementById('in_page_previous');
        if (typeof elem !== 'undefined') elem.classList.add('hover');
      }
    }
    onkeyup = (e) => {
      if (e.key == 'ArrowRight') {
        e.preventDefault();
        const elem = document.getElementById('in_page_next');
        if (typeof elem !== 'undefined') elem.classList.remove('hover');
        this.move(true);
      }
      if (e.key == 'ArrowLeft') {
        e.preventDefault();
        const elem = document.getElementById('in_page_previous');
        if (typeof elem !== 'undefined') elem.classList.remove('hover');
        this.move(false);
      }
    }
  }

  move(isForward) {
    this.current = isForward ? this.current + 1 : this.current - 1;
    this.current = this.current < 0 ? 0 : this.current >= this.length ? this.length - 1 : this.current;
    this.setCurrentNavi(this.current);
    this.updateComponent(this.elements[this.current]);
    VueScrollTo.scrollTo(".content", 1500, {offset: -40});
  }

}